module.exports = __webpack_public_path__ + "static/media/Devon.992ae946.jpg";